export default {
  'TITLE_TAB': 'Redes WiFi',
  'TITLE': 'Redes WiFi PLUS+',
  'NETWORK_ERROR': 'Se ha producido un error en la red principal',
  'PASSWORD_NETWORK_ERROR': 'Se ha producido un error en la red con contraseña',
  'CLIENT_WIFI': 'Red de invitados',
  'EMPLOYEES_WIFI': 'Red de empleados',
  'CONTENT_FILTERS': 'Filtros de bloqueo red clientes',
  'CONTENT_FILTERS_EMPLOYEES': 'Filtros de bloqueo red empleados',
  'APPLICATIONS': 'Aplicaciones',
  'APP_CATEGORIES': 'Categorías de App',
  'WEB_CATEGORIES': 'Categorías de páginas web',
  'SAVE_BUTTON': 'Guardar',
  'DEVICE_BANDWIDTH': 'Ancho de banda por dispositivo',
  'BASE_INPUTS': {
    'SSID': 'Elige con que nombre tus clientes buscarán tu red',
    'SSID_WITH_PWD': 'Elige con que nombre tus empleados buscarán tu red',
    'LIMIT_DOWN': 'MB de bajada',
    'LIMIT_UP': 'MB de subida',
  },
  'CATEGORIES_CHECKBOXES': {
    'ADULT_CONTENT': 'Contenido adulto y pornografía',
    'GAMES': 'Juegos',
    'DRUGS': 'Drogas',
    'WEAPONS': 'Armas',
  },
  'ENABLE_PASSWORD': 'Habilitar red con contraseña',
  'PASSWORD_PLACEHOLDER': 'Editar contraseña',
  'PASSWORD_CONFIRMATION_PLACEHOLDER': 'Confirmar contraseña',
  'FORM_VALIDATION': {
    'PASSWORD_CONFIRMATION': 'Contraseñas no coinciden',
    'INVALID_PASSWORD': 'Los caracteres aceptados incluyen letras minúsculas y mayúsculas (exceptuando las letras con tilde y la letra "ñ"), además de dígitos y símbolos especiales tales como @ y #.',
  },
}